(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ---------- Reveals ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in-view');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('.reveal, .mask').forEach(function (el) { io.observe(el); });
    $$('.grid, .tiles, .features, .trust, .values, .trio, .claims ul').forEach(function (list) {
      $$('.reveal', list).forEach(function (el, i) { el.style.transitionDelay = (Math.min(i, 8) * 80) + 'ms'; });
    });
    $$('.hero__copy .reveal').forEach(function (el, i) { el.style.transitionDelay = (i * 110) + 'ms'; });
  } else {
    $$('.reveal, .mask').forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ---------- Parallax: story panel, closer, hero drift ---------- */
  var panel = $('#storyPanel'), closerBg = $('.closer__bg'), heroProduct = $('#heroProduct');
  function updateParallax() {
    if (reduce) return;
    var vh = window.innerHeight;
    if (panel) {
      var r = panel.getBoundingClientRect();
      var p = clamp(1 - (r.top - vh * 0.15) / (vh * 0.6), 0, 1);
      panel.style.setProperty('--s', (0.9 + 0.1 * p).toFixed(4));
    }
    if (closerBg) {
      var c = closerBg.parentElement.getBoundingClientRect();
      var q = clamp((vh - c.top) / (vh + c.height), 0, 1);
      closerBg.style.setProperty('--z', (1.18 - 0.12 * q).toFixed(4));
    }
    if (heroProduct) {
      var y = clamp(window.scrollY, 0, vh);
      heroProduct.style.transform = 'translateY(' + (y * 0.08).toFixed(1) + 'px)';
    }
  }

  /* ---------- Sticky dock ---------- */
  var dock = $('#dock'), dockAfter = $('[data-dock-after]'), closer = $('.closer');
  function updateDock() {
    if (!dock || !dockAfter) return;
    var past = dockAfter.getBoundingClientRect().bottom < 0;
    var atCloser = closer && closer.getBoundingClientRect().top < window.innerHeight * 0.5;
    dock.classList.toggle('is-on', past && !atCloser);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { updateParallax(); updateDock(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* ---------- Mobile menu ---------- */
  var menu = $('#menu');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); document.body.style.overflow = ''; }); });

  /* ---------- Magnetic CTAs ---------- */
  if (!reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    $$('.magnetic').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - r.left - r.width / 2) * 0.18, dy = (e.clientY - r.top - r.height / 2) * 0.28;
        btn.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Accordion: one open at a time ---------- */
  $$('.accordion').forEach(function (acc) {
    var details = $$('details', acc);
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) details.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* ---------- Gallery ---------- */
  var main = $('#galleryMain');
  if (main) {
    $$('.gallery__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.gallery__thumbs button').forEach(function (o) { o.classList.remove('is-on'); });
        b.classList.add('is-on');
        var src = b.getAttribute('data-src'), alt = b.getAttribute('data-alt') || main.alt;
        if (reduce) { main.src = src; main.alt = alt; return; }
        main.classList.add('is-fading');
        setTimeout(function () { main.src = src; main.alt = alt; main.onload = function () { main.classList.remove('is-fading'); }; }, 180);
      });
    });
  }

  /* ---------- Variant select -> cart link ---------- */
  var sel = $('#variantSelect');
  if (sel) {
    var apply = function () {
      var id = sel.value, price = sel.options[sel.selectedIndex].getAttribute('data-price');
      $$('[data-cart-id]').forEach(function (inp) { inp.value = id; });
      $$('[data-price-out]').forEach(function (el) { if (price) el.textContent = '$' + price; });
    };
    sel.addEventListener('change', apply); apply();
  }

  /* ---------- Mood filter (collection) ---------- */
  var filter = $('[data-filter]');
  if (filter) {
    var scope = filter.parentElement, cards = $$('.grid [data-mood]', scope), empty = $('.grid__empty', scope);
    $$('.chip', filter).forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('.chip', filter).forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on');
        var m = chip.getAttribute('data-mood'), shown = 0;
        cards.forEach(function (c) {
          var on = m === 'all' || (' ' + c.getAttribute('data-mood') + ' ').indexOf(' ' + m + ' ') > -1;
          c.classList.toggle('is-hidden', !on); if (on) shown++;
        });
        if (empty) empty.classList.toggle('is-on', shown === 0);
      });
    });
  }

  /* ---------- Scent finder (home) ---------- */
  var finder = $('[data-finder]');
  if (finder) {
    var data = JSON.parse($('#finderData').textContent), result = $('.finder__result', finder);
    var img = $('.finder__img img', finder), kicker = $('[data-f-kicker]', finder), name = $('[data-f-name]', finder);
    var blurb = $('[data-f-blurb]', finder), notes = $('[data-f-notes]', finder), link = $('[data-f-link]', finder), alt = $('[data-f-alt]', finder), cart = $('[data-f-cart]', finder);
    function show(mood) {
      var list = data.filter(function (p) { return p.mood.indexOf(mood) > -1; });
      if (!list.length) return;
      var top = list[0], rest = list.slice(1);
      var swap = function () {
        img.src = top.img; img.alt = top.title;
        kicker.textContent = top.family + ' · ' + top.burn;
        name.textContent = top.title;
        blurb.textContent = top.one;
        notes.innerHTML = top.notes.map(function (n) { return '<li>' + n + '</li>'; }).join('');
        link.href = top.url; if (cart) cart.value = top.variant;
        alt.innerHTML = rest.length ? 'Also fits: ' + rest.map(function (p) { return '<a href="' + p.url + '">' + p.short + '</a>'; }).join(', ') : '';
      };
      if (reduce) { swap(); return; }
      result.classList.add('is-swapping');
      setTimeout(function () { swap(); img.onload = function () { result.classList.remove('is-swapping'); }; }, 260);
    }
    $$('.chip', finder).forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('.chip', finder).forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on'); show(chip.getAttribute('data-mood'));
      });
    });
  }
})();
